import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Icon, IconButton, FontSizes, FontWeights, AnimationStyles, mergeStyleSets } from '@fluentui/react';
import ButtonTooltip from '@v2/components/base/ButtonTooltip';

const classNames = mergeStyleSets({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: 42,

    padding: '0px 16px 0px 16px',
    cursor: 'pointer',

    fontSize: FontSizes.large,
    fontWeight: FontWeights.semilight,

    selectors: {
      '& span': {
        marginLeft: 16,
      },
      '& i': {
        transform: 'rotate(0deg)',
        transformOrigin: '50% 50% 0px',
        transition: 'transform 0.1s linear 0s',
      },
      ':hover': {
        backgroundColor: '#F4F4F4',
      },
    },
  },
  collapsed: {
    transform: 'rotate(-90deg) !important',
  },
  content: {
    ...AnimationStyles.fadeIn100,
  },
})

const GroupPane = ({ title, tooltip, children, onCollapsed, collapsed = true, className }) => {
  const [isCollapsed, setCollapsed] = useState(collapsed);

  return (
    <div className={classnames(classNames.root, className)}>
      <div className={classNames.header}
        onClick={() => {
          onCollapsed && onCollapsed(!isCollapsed);
          setCollapsed(!isCollapsed);
        }}>

        <Icon className={ isCollapsed && classNames.collapsed } iconName={ 'ChevronDown' } />
        <span>{title}</span>

        { tooltip &&
          <ButtonTooltip
            content={tooltip}
            styles={{ root: { width: 'auto'}}}
          >
            <IconButton iconProps={{ iconName: 'Info' }} />
          </ButtonTooltip>
        }

      </div>
      { !isCollapsed && <div className={classNames.content}>{children}</div> }
    </div>
  )
}

GroupPane.propTypes = {
  title: PropTypes.string.isRequired,
  collapsed: PropTypes.bool,
}

export default GroupPane;